<template>
  <div>
    <CategoryInput
      v-for="c in categories"
      :key="c"
      :category="c"
      :services="byCategory[c]"
      :value="value"
      :offered_ids="offered_ids"
      :claimed="claimed"
      @input="servicesChange"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CategoryInput from './CategoryInput'

export default {  
  components: { CategoryInput },

  props: ['value', 'offered_ids', 'claimed'],

  computed: {
    ...mapGetters('services',  ['byCategory', 'categories']),
  },

  methods: {
    ...mapActions('services', ['loadAll']),

    servicesChange(newVal) {
      this.$emit('input', newVal)
    },
  },

  created() {
    this.loadAll()
  },
}
</script>